<template>
  <v-card>
    <v-card-title>
      Tickets
      <v-spacer v-if="user.admin == true"></v-spacer>
      <v-btn v-if="user.admin == true" small color="red darken-2" dark @click="deleteTickets" >Delete Selected</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="user.admin== true ? headers : editorHeaders" :items="tickets" :pagination.sync="pagination" v-model="selected" select-all item-key="_id" class="elevation-1" :total-items="amount" :rows-per-page-items="listSize">
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              @click.native="toggleAll"
              :input-value="props.all"
              :indeterminate="props.indeterminate"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.text=='Action' ? 'text-xs-center' : 'text-xs-left']"
            @click="changeSort(header.value)"
          > 
            {{ header.text }}
            <v-icon>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="user.admin == true">
            <v-checkbox
              primary
              hide-details
              :input-value="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.subject }}</td>
          <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
          <td class="text-xs-center">
            <v-btn color="red darken-2" v-if="props.item.status!='Open'" small flat @click="activateModal(props.item)">
              Closed
            </v-btn>

             <v-btn color="blue" v-if="props.item.status=='Open'" small flat @click="deactivateModal(props.item)">
              Open
            </v-btn>
          </td>
          <td v-if="user.admin== true || user.editor== true || user.manager== true">
            <v-btn icon @click="editModal(props.item)">
              <v-icon color="orange darken-2">edit</v-icon>
            </v-btn>
          </td>
          <td class v-if="user.admin== true">
            <v-btn icon @click="deleteModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
        </tr>  
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this ticket?</h5>
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.subject"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteTicket" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->


    <!-- activate dialog -->
    <v-dialog v-model="activate_dialog" max-width="750px">
      <v-toolbar class="primary" dark dense>
        <v-toolbar-title>Open Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="activate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.subject"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>

            <v-flex xs12>
              <v-btn color="primary" class="right" small dark @click="activate" :loading="loader">
                <v-icon left>thumb_up</v-icon> Open
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of activate modal  -->


        <!-- deactivate dialog -->
    <v-dialog v-model="deactivate_dialog" max-width="750px">
      <v-toolbar class="orange darken-2" dark dense>
        <v-toolbar-title>Close Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="deactivate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.subject"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <ckeditor v-model="dataItem.description" label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>

            <v-flex xs12>
              <v-btn color="orange darken-2" class="right" small dark @click="deactivate" :loading="loader">
                <v-icon left>thumb_down</v-icon> Close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of deactivate modal  -->

    <!-- Editor editing -->
    <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="editDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- snackbar -->
              <snackbar ref="mySnackbar"></snackbar>
              <!-- end of snackbar -->
              <v-flex md4 xs12 sm12>
                <h4>Ticket No: <span class="font-weight-regular">{{editItem.ticket_no}}</span></h4>
              </v-flex>
              <v-flex md4 xs12 sm12>
                <h4>Posted On: <span class="font-weight-regular">{{editItem.createdAt | moment("DD MMMM YYYY") }}</span></h4>
              </v-flex>
              <v-flex md4 xs12 sm12>
                <h4>Posted By: <span class="font-weight-regular">{{editItem.userName}}</span></h4>
              </v-flex>
              <v-flex xs12 sm12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 sm12>
                <p class="font-weight-bold">Subject: <span class="font-weight-regular">{{editItem.subject}}</span></p>
              </v-flex>
              <v-flex xs12 sm12>
                <p class="font-weight-bold">Description: <div v-html="editItem.description"></div></p>
              </v-flex>
              
              <v-flex xs12 sm12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 sm12>
                <h3 class="primary--text">Comments</h3>
              </v-flex>
              <v-flex xs12 sm12 v-if="editItem.replies" v-for="reply in editItem.replies" :key="reply._id">
                <div class="font-weight-bold">Posted by <span class="font-weight-regular">{{reply.userId.firstName}} {{reply.userId.lastName}}</span> at <span class="font-weight-regular caption grey--text">{{reply.createdAt | moment("DD MMMM YYYY h:mm:ss a") }}</span></div>
                <div v-html="reply.comments"></div>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12 class="mt-2">
                <ckeditor v-model="comment" id="comment"
                  data-vv-name="comment"  label="Reply" :editor="editor" :config="editorConfig"></ckeditor>
              </v-flex>
              <v-flex xs12>
                <v-btn class="primary" @click="save" :loading="loader">
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End -->

  </v-card>
</template>

<script>
import Snackbar from "@/components/global/snackbar.vue";
import { mapGetters } from "vuex";
import { trimDescription } from "@/common/methods.js";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import FileUpload from "@/components/shared/file-uploader.vue";
export default {
  components: {
    CKEditor,
    Snackbar,
    FileUpload
  },
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  /*props: {
    blogs: {
      type: Array,
      default: [],
      required: true
    }
  },*/
  data() {
    return {
      comment: "",
      search: "",
      delete_dialog: false,
      activate_dialog: false,
      deactivate_dialog: false,
      pagination: {rowsPerPage: 25,page: 1, sortBy: 'title'},
      dataItem: {},
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      loader: false,
      headers: [
        {
          text: "Subject",
          align: "left",
          sortable: false,
          value: "subject"
        },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "activation", class: "text-xs-center" },
        { text: "Respond", value: "Edit" },
        { text: "Delete", value: "action" }
      ],
      editorHeaders: [
        {
          text: "Subject",
          align: "left",
          sortable: false,
          value: "subject"
        },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "activation", class: "text-xs-center" },
        { text: "Respond", value: "Edit" },
      ],
      editDialog: false,
      editItem: {},
      ticketError: '',
      selected: [],
      editor: ClassicEditor,
      editorConfig: {
        link: { addTargetToExternalLinks: true },
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        }
      },
      amount: 0,
      tickets: [],
      selected: [],
    };
  },
  methods: {
    editModal(item) {
      this.editItem = Object.assign({}, item);
      this.editDialog = true;
      this.ticketError = '';
    },
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    activateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.activate_dialog = true;
    },
    deactivateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.deactivate_dialog = true;
    },
    deleteTicket() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/ticket/delete", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    activate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/ticket/activate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    deactivate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/ticket/deactivate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    save() {

      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {          
          if(this.comment == undefined || this.comment == null || this.comment.length == 0){
            this.$refs.mySnackbar.show("Please enter reply", "red");
          } else{
            const ticketData = {
              userId: this.user._id,
              comments: this.comment,
              ticketId: this.editItem._id,
            };
            const formData = new FormData();
            formData.append("options", JSON.stringify(ticketData));
            const data = formData;
            this.loader = true;
            const self = this;
            const res = this.$store
              .dispatch("post", { url: "/ticketreply", data })
              .then(res => {
                self.loader = false;
                location.reload();
            });
          }
        }
      });
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.blogs.slice()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    fetchData() {
        return new Promise((resolve, reject) => {
            let search = this.search.trim().toLowerCase();
            const {rowsPerPage, page} = this.pagination;
            if(search !== '') {
              search = `/`+search;  
            }
            let sortBy = '/'+this.pagination.sortBy;
            let order  = -1;
            if(this.pagination.descending == false) {
              order = 1;
            }
            let sortOrder = '/'+order;
            this.$store.dispatch("get", `/ticket/expert/get`+sortBy+sortOrder+'/'+page+`/`+rowsPerPage+search).then(res => {
              this.tickets = res.tickets;
              const {
                  sortBy,
                  descending,
                  page,
                  rowsPerPage
              } = this.pagination;
              this.amount = res.amount;
              resolve();
            });
        });
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.fundis.slice()
      }
    },
    deleteTickets() {
      const tickets = [];
      this.selected.forEach((value, index) => {
        tickets.push(value._id);
      });
      this.loader = true;
      const data = {
        tickets: tickets
      };
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/ticket/all/delete", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
  },
  watch: {
    pagination: {
        handler() {
            this.fetchData();
        },
        deep: true
    },
    search() {
        this.pagination.page = 1;
        this.pagination.rowsPerPage = 25;
        this.fetchData();
    }
  },
  /*mounted() {
        this.fetchData();
  }*/
};
</script>